import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Global from '../../store/global-selectors';
import { shipmentGridChangePage } from '../../store/shipments/grid/shipments.grid.actions';
import { PagingControl } from '../../components/paging-control';

export const ShipmentsGridPagingControl = () => {
  const dispatch = useDispatch();
  const page = useSelector(Global.selectShipmentsGridPage);
  const pageSize = useSelector(Global.selectShipmentsGridPageSize);
  const totalPages = useSelector(Global.selectShipmentsGridTotalPages);
  const totalRecords = useSelector(Global.selectShipmentsGridTotalRecords);
  const viewStartingCount = useSelector(Global.selectShipmentsGridViewStartingCount);
  const viewEndingCount = useSelector(Global.selectShipmentsGridViewEndingCount);
  const numberSelected = useSelector(Global.selectSelectedShipmentsCount) || 0;
  const onPageChange = useCallback((newPage, newPageSize) => dispatch(shipmentGridChangePage(newPage, newPageSize)), [dispatch]);

  return (
    <PagingControl
      numberSelected={numberSelected}
      onPageChange={onPageChange}
      page={page}
      pageSize={pageSize}
      totalPages={totalPages}
      totalRecords={totalRecords}
      viewEndingCount={viewEndingCount}
      viewStartingCount={viewStartingCount}
    />
  );
};
